/** @jsxImportSource @emotion/react */
import { useEffect, useRef, useState } from 'react';

import { recommendationsPageAnalytics } from '../../analyticsConsts';
import ExternalLink from '../ExternalLink';
import {
  closeButton,
  videoContainer,
  videoOverlay,
  videoWrapper,
} from '../FAProgrammes/styles';
import Link from '../Link';
import Text from '../Text';
import useStyles from './styles';

const { FOOTBALL_RECOMMENDATIONS_RESULTS_TABS } = recommendationsPageAnalytics;
const WaysToPlayMobile = ({
  heading,
  description,
  footer,
  images,
  indexVal,
  ctaId,
  videos,
  href,
}) => {
  const styles = useStyles();
  const [showVideo, setShowVideo] = useState(false);
  const descriptionRef = useRef(null);
  const [showExpandLink, setShowExpandLink] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [cardTouched, setCardTouched] = useState(false);

  const disableScrolling = () => {
    document.documentElement.style.overflow = 'hidden';
  };

  const enableScrolling = () => {
    document.documentElement.style.overflow = '';
  };

  const handleClick = () => {
    setShowVideo(true);
    disableScrolling();
  };

  const handleCloseVideo = e => {
    e.stopPropagation();
    setShowVideo(false);
    enableScrolling();
  };

  const handleKeyDown = (e, action) => {
    switch (e.key) {
      case 'Enter':
        if (e.key === 'Enter') {
          e.preventDefault();
        }
        if (action === 'buttonClick') {
          handleExpandClick(e);
        }
        if (action === 'buttonCollapseClick') {
          handleCollapseClick(e);
        }
        if (action === 'open') {
          handleClick();
        } else if (action === 'close') {
          handleCloseVideo(e);
        }
        break;

      default:
        break;
    }
  };
  const extractTextFromJSX = jsx => {
    if (typeof jsx === 'string') {
      return jsx;
    }
    if (Array.isArray(jsx)) {
      return jsx.map(extractTextFromJSX).join('');
    }
    if (jsx?.props?.children) {
      return extractTextFromJSX(jsx.props.children);
    }
    return '';
  };

  const plainTextDescription = extractTextFromJSX(description);

  const renderDescriptionBold = des => {
    const phrase = 'Walking Football';
    const regex = new RegExp(phrase, 'g');

    return (
      <>
        <span
          dangerouslySetInnerHTML={{
            __html: des.replace(regex, `<b>${phrase}</b>`),
          }}
        ></span>
      </>
    );
  };

  useEffect(() => {
    if (descriptionRef.current) {
      const element = descriptionRef.current;
      const lineHeight = parseFloat(
        window.getComputedStyle(element).lineHeight
      );

      const scrollHeight = element.scrollHeight;

      const lines = Math.ceil(scrollHeight / lineHeight);

      setShowExpandLink(() => {
        const shouldShow = lines > 5 ? true : false;
        return shouldShow;
      });
    }
  }, [description]);

  const handleExpandClick = e => {
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded(true);
  };

  const handleCollapseClick = e => {
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded(false);
  };

  return (
    <div css={styles.base} id={FOOTBALL_RECOMMENDATIONS_RESULTS_TABS}>
      <div css={styles.waysContainer}>
        <div css={styles.waysToPlaycards} id={ctaId}>
          <div css={styles.innerWrapper}>
            <div css={styles.card}>
              <Link
                css={styles.imgSection(images, indexVal)}
                tabIndex={0}
                onClick={handleClick}
                onKeyDown={e => handleKeyDown(e, 'open')}
              >
                {showVideo && (
                  <div
                    css={videoOverlay}
                    onClick={handleCloseVideo}
                    onKeyDown={e => handleKeyDown(e, 'close')}
                    tabIndex={0}
                    role="button"
                  >
                    <div
                      css={videoContainer}
                      onClick={e => e.stopPropagation()}
                      onKeyDown={e => e.stopPropagation()}
                      tabIndex={0}
                      role="button"
                    >
                      <div css={videoWrapper}>
                        <iframe
                          width="100%"
                          height="100%"
                          src={videos}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          title="video"
                        ></iframe>
                        <img
                          css={closeButton}
                          src="/images/desktop/home/closeLightboxVideo.svg"
                          alt="Close Video"
                          onClick={handleCloseVideo}
                          onKeyDown={e => handleKeyDown(e, 'close')}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {!showVideo && (
                  <div css={styles.imageWrapper}>
                    <img
                      src="/images/desktop/home/VideoPlay.png"
                      alt="Play Video"
                      onClick={handleClick}
                      className="youtube"
                      onKeyDown={e => handleKeyDown(e, 'open')}
                    />
                  </div>
                )}
              </Link>

              <div css={styles.infoSection}>
                <div css={styles.cardalign(isExpanded)}>
                  <Text
                    as="p"
                    css={styles.header}
                    tabIndex={0}
                    role="link"
                    onClick={handleClick}
                    onKeyDown={e => handleKeyDown(e, 'open')}
                  >
                    {heading}
                  </Text>
                  <Text
                    css={styles.description(isExpanded)}
                    ref={descriptionRef}
                    id={`description-section-${ctaId}`}
                    tabIndex={0}
                    role="link"
                    onClick={handleClick}
                    onKeyDown={e => handleKeyDown(e, 'open')}
                  >
                    {showExpandLink && (
                      <>
                        {!isExpanded ? (
                          <>
                            {renderDescriptionBold(
                              plainTextDescription.slice(0, 167)
                            )}
                            ...{' '}
                          </>
                        ) : (
                          <>{renderDescriptionBold(plainTextDescription)}</>
                        )}

                        <span
                          onClick={
                            !isExpanded
                              ? handleExpandClick
                              : handleCollapseClick
                          }
                          onKeyDown={e =>
                            !isExpanded
                              ? handleKeyDown(e, 'buttonClick')
                              : handleKeyDown(e, 'buttonCollapseClick')
                          }
                          css={styles.showMore}
                          tabIndex={0}
                          role="button"
                        >
                          {!isExpanded ? 'show more' : 'show less'}
                          <span css={styles.expandArrow}>
                            <img
                              src={
                                !isExpanded
                                  ? '/images/desktop/home/disabilityFootball/downArrow.svg'
                                  : '/images/desktop/home/disabilityFootball/upArrow.svg'
                              }
                              alt="/images/desktop/home/disabilityFootball/downArrow.svg"
                            />
                          </span>
                        </span>
                      </>
                    )}
                    <div>
                      {' '}
                      {!showExpandLink && <>{plainTextDescription} </>}
                    </div>
                  </Text>
                  <ExternalLink
                    css={styles.link}
                    href={href}
                    onTouchStart={() => setCardTouched(true)}
                    onTouchEnd={() => setCardTouched(false)}
                  >
                    <Text css={styles.learnMore} tabIndex={0}>
                      <span css={styles.learnmore}>{footer}</span>
                      <img
                        css={styles.learnmoreArrow}
                        src={
                          cardTouched
                            ? '/images/desktop/home/rightArrowBlue.svg'
                            : '/images/desktop/home/rightArrow.svg'
                        }
                        alt="/images/desktop/home/rightArrow.svg"
                      />{' '}
                    </Text>
                  </ExternalLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaysToPlayMobile;
